exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nstrong {\n    font-weight: 500;\n}\n.line-through {\n    text-decoration: line-through;\n}\n", ""]);

// exports
